import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Music from './components/Music';
import Live from './components/Live';
import Csr from './components/Csr';
import Media from './components/Media';
import Booking from './components/Booking';
import Footer from './components/Footer';
import VideoModal from './components/VideoModal';
import AboutPage from './pages/AboutPage';
import MusicPage from './pages/MusicPage';
import Seo from './components/Seo';
import { SEO_META } from './mock';
import EventsPage from './pages/EventsPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import CsrPage from './pages/CsrPage';
import LegalPage from './pages/LegalPage';

const TOAST_OPTIONS = {
  style: {
    background: '#141312',
    border: '1px solid rgba(227,167,43,0.4)',
    color: '#f4eee2',
  },
};

const HomePage = ({ onPlay }) => (
  <main>
    <Seo {...SEO_META.home} />
    <Hero />
    <About />
    <Music onPlay={onPlay} />
    <Live />
    <Csr />
    <Media />
    <Booking />
  </main>
);

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [videoTrack, setVideoTrack] = useState(null);

  return (
    <div className="min-h-screen bg-ink font-sans text-white antialiased">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage onPlay={setVideoTrack} />} />
          <Route path="/about" element={<AboutPage onPlay={setVideoTrack} />} />
          <Route path="/music" element={<MusicPage onPlay={setVideoTrack} />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/csr" element={<CsrPage />} />
          <Route path="/privacy" element={<LegalPage which="privacy" />} />
          <Route path="/terms" element={<LegalPage which="terms" />} />
        </Routes>
        <Footer />

        <VideoModal track={videoTrack} onClose={() => setVideoTrack(null)} />
        <Toaster position="top-center" theme="dark" toastOptions={TOAST_OPTIONS} />
      </BrowserRouter>
    </div>
  );
}

export default App;
